export default __webpack_public_path__ + "static/media/Samy Adamou.f780b8e8.svg";